/**
 * Skin atlas layout. Each body part gets a region of the skin canvas whose
 * aspect ratio matches that part's front face, so a drawing maps on WITHOUT
 * stretching. Coordinates are fractions of the canvas (x,y from TOP-LEFT).
 * The avatar remaps each box's UVs onto its region; the Skin Lab draws these
 * same regions as labeled guides so you paint in correctly-shaped areas.
 */
export interface SkinRegion {
  x: number;
  y: number;
  w: number;
  h: number;
  label: string;
}

// aspect targets: head ≈ square, torso ≈ 1.3:1 wide, arms/legs ≈ thin & tall
export const SKIN_REGIONS: Record<string, SkinRegion> = {
  head: { x: 0.03, y: 0.04, w: 0.40, h: 0.42, label: "HEAD / FACE" },
  torso: { x: 0.50, y: 0.06, w: 0.46, h: 0.36, label: "TORSO" },
  armL: { x: 0.05, y: 0.54, w: 0.13, h: 0.42, label: "L ARM" },
  armR: { x: 0.22, y: 0.54, w: 0.13, h: 0.42, label: "R ARM" },
  legL: { x: 0.52, y: 0.54, w: 0.15, h: 0.42, label: "L LEG" },
  legR: { x: 0.72, y: 0.54, w: 0.15, h: 0.42, label: "R LEG" },
};
